// import React, { useState, useEffect } from 'react';
// import {
//   AppBar, Toolbar, Typography, Button, Box, IconButton,
//   Drawer, List, ListItem, ListItemText, useScrollTrigger, Slide
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';
// import CameraAltIcon from '@mui/icons-material/CameraAlt';

// const navLinks = ['Home', 'Services', 'Products', 'About', 'Contact'];

// export default function Navbar() {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 60);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollTo = (section) => {
//     const el = document.getElementById(section.toLowerCase());
//     if (el) el.scrollIntoView({ behavior: 'smooth' });
//     setDrawerOpen(false);
//   };

//   return (
//     <>
//       <AppBar
//         position="fixed"
//         elevation={scrolled ? 8 : 0}
//         sx={{
//           background: scrolled
//             ? 'rgba(8, 30, 53, 0.97)'
//             : 'transparent',
//           backdropFilter: scrolled ? 'blur(12px)' : 'none',
//           borderBottom: scrolled ? '1px solid rgba(30,144,212,0.2)' : 'none',
//           transition: 'all 0.4s ease',
//         }}
//       >
//         <Toolbar sx={{ py: 1.5, maxWidth: 1200, mx: 'auto', width: '100%' }}>
//           {/* Logo */}
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1 }}>
//             <Box sx={{
//               width: 42, height: 42,
//               background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
//               borderRadius: '8px',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               boxShadow: '0 0 20px rgba(30,144,212,0.4)',
//             }}>
//               <CameraAltIcon sx={{ color: '#fff', fontSize: 22 }} />
//             </Box>
//             <Box>
//               <Typography variant="h6" sx={{
//                 fontFamily: '"Playfair Display", serif',
//                 fontWeight: 900, letterSpacing: '1px',
//                 fontSize: '1.2rem', lineHeight: 1,
//                 color: '#e8f0fe',
//               }}>
//                 CCTV <span style={{ color: '#1e90d4' }}>PARTNER</span>
//               </Typography>
//               <Typography sx={{ fontSize: '0.6rem', letterSpacing: '2px', color: '#8fb3d9', textTransform: 'uppercase' }}>
//                 Eagle Eye Surveillance
//               </Typography>
//             </Box>
//           </Box>

//           {/* Desktop Links */}
//           <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, alignItems: 'center' }}>
//             {navLinks.map((link) => (
//               <Button
//                 key={link}
//                 onClick={() => scrollTo(link)}
//                 sx={{
//                   color: '#8fb3d9', px: 2,
//                   '&:hover': { color: '#1e90d4', background: 'rgba(30,144,212,0.08)' },
//                   transition: 'all 0.2s',
//                 }}
//               >
//                 {link}
//               </Button>
//             ))}
//             <Button
//               variant="contained"
//               onClick={() => scrollTo('Contact')}
//               sx={{
//                 ml: 1,
//                 background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
//                 px: 3,
//                 boxShadow: '0 4px 20px rgba(30,144,212,0.4)',
//                 '&:hover': { boxShadow: '0 6px 28px rgba(30,144,212,0.6)' },
//               }}
//             >
//               Get Quote
//             </Button>
//           </Box>

//           {/* Mobile Menu */}
//           <IconButton
//             sx={{ display: { xs: 'flex', md: 'none' }, color: '#e8f0fe' }}
//             onClick={() => setDrawerOpen(true)}
//           >
//             <MenuIcon />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       <Drawer
//         anchor="right"
//         open={drawerOpen}
//         onClose={() => setDrawerOpen(false)}
//         PaperProps={{
//           sx: {
//             width: 280,
//             background: 'rgba(8,30,53,0.98)',
//             backdropFilter: 'blur(20px)',
//             borderLeft: '1px solid rgba(30,144,212,0.2)',
//           }
//         }}
//       >
//         <Box sx={{ p: 3 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
//             <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: '#8fb3d9' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//           <List>
//             {navLinks.map((link) => (
//               <ListItem
//                 key={link}
//                 button
//                 onClick={() => scrollTo(link)}
//                 sx={{
//                   borderBottom: '1px solid rgba(30,144,212,0.1)',
//                   '&:hover': { background: 'rgba(30,144,212,0.1)', pl: 3 },
//                   transition: 'all 0.2s', borderRadius: 1, mb: 0.5
//                 }}
//               >
//                 <ListItemText primary={link} sx={{ color: '#e8f0fe' }} />
//               </ListItem>
//             ))}
//           </List>
//           <Button
//             fullWidth variant="contained"
//             onClick={() => scrollTo('Contact')}
//             sx={{
//               mt: 3,
//               background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
//               py: 1.5,
//             }}
//           >
//             Get Free Quote
//           </Button>
//         </Box>
//       </Drawer>
//     </>
//   );
// }

import React, { useState, useEffect } from 'react';
import {
  AppBar, Toolbar, Typography, Button, Box, IconButton,
  Drawer, List, ListItem, ListItemText
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom'; // हे दोन hooks महत्वाचे आहेत
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const navLinks = ['Home', 'Services', 'Products', 'About', 'Contact'];

export default function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavAction = (link) => {
    const sectionId = link.toLowerCase();

    // १. जर युजर 'Home' वर क्लिक करेल तर थेट होमला जा
    if (link === 'Home') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } 
    // २. जर युजर सध्या होम पेजवर नसेल (उदा. Privacy पेजवर असेल)
    else if (location.pathname !== '/') {
      navigate('/'); // आधी होमला न्या
      // होम पेज लोड होण्यासाठी थोडा वेळ द्या आणि मग स्क्रोल करा
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    } 
    // ३. जर आधीच होम पेजवर असेल
    else {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    
    setDrawerOpen(false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={scrolled ? 8 : 0}
        sx={{
          background: scrolled ? 'rgba(8, 30, 53, 0.97)' : 'transparent',
          backdropFilter: scrolled ? 'blur(12px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(30,144,212,0.2)' : 'none',
          transition: 'all 0.4s ease',
        }}
      >
        <Toolbar sx={{ py: 1.5, maxWidth: 1200, mx: 'auto', width: '100%' }}>
          {/* Logo - क्लिक केल्यावर होमला जाण्यासाठी */}
          <Box 
            onClick={() => handleNavAction('Home')}
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1, cursor: 'pointer' }}
          >
            <Box sx={{
              width: 42, height: 42,
              background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
              borderRadius: '8px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 0 20px rgba(30,144,212,0.4)',
            }}>
              <CameraAltIcon sx={{ color: '#fff', fontSize: 22 }} />
            </Box>
            <Box>
              <Typography variant="h6" sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 900, letterSpacing: '1px',
                fontSize: '1.2rem', lineHeight: 1,
                color: '#e8f0fe',
              }}>
                CCTV <span style={{ color: '#1e90d4' }}>PARTNER</span>
              </Typography>
              <Typography sx={{ fontSize: '0.6rem', letterSpacing: '2px', color: '#8fb3d9', textTransform: 'uppercase' }}>
                Eagle Eye Surveillance
              </Typography>
            </Box>
          </Box>

          {/* Desktop Links */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, alignItems: 'center' }}>
            {navLinks.map((link) => (
              <Button
                key={link}
                onClick={() => handleNavAction(link)}
                sx={{
                  color: '#8fb3d9', px: 2,
                  '&:hover': { color: '#1e90d4', background: 'rgba(30,144,212,0.08)' },
                  transition: 'all 0.2s',
                }}
              >
                {link}
              </Button>
            ))}
            <Button
              variant="contained"
              onClick={() => handleNavAction('Contact')}
              sx={{
                ml: 1,
                background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
                px: 3,
                boxShadow: '0 4px 20px rgba(30,144,212,0.4)',
                '&:hover': { boxShadow: '0 6px 28px rgba(30,144,212,0.6)' },
              }}
            >
              Get Quote
            </Button>
          </Box>

          {/* Mobile Menu */}
          <IconButton
            sx={{ display: { xs: 'flex', md: 'none' }, color: '#e8f0fe' }}
            onClick={() => setDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Drawer (Mobile Menu) */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: 280,
            background: 'rgba(8,30,53,0.98)',
            backdropFilter: 'blur(20px)',
            borderLeft: '1px solid rgba(30,144,212,0.2)',
          }
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
            <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: '#8fb3d9' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((link) => (
              <ListItem
                key={link}
                button
                onClick={() => handleNavAction(link)}
                sx={{
                  borderBottom: '1px solid rgba(30,144,212,0.1)',
                  '&:hover': { background: 'rgba(30,144,212,0.1)', pl: 3 },
                  transition: 'all 0.2s', borderRadius: 1, mb: 0.5
                }}
              >
                <ListItemText primary={link} sx={{ color: '#e8f0fe' }} />
              </ListItem>
            ))}
          </List>
          <Button
            fullWidth variant="contained"
            onClick={() => handleNavAction('Contact')}
            sx={{
              mt: 3,
              background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
              py: 1.5,
            }}
          >
            Get Free Quote
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
